import { getAppRouter } from '../Common/Components/Routes/Routes';
import { loadApp } from '../Common/Utilities/App.js';
import RatesRoutes from './RatesRoutes.jsx';
import { store } from './Redux/RatesStore';

loadApp(getAppRouter("/App/Rates/", RatesRoutes, store));
